import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Button,
  Divider,
  Checkbox,
  TextField,
  Paper, Dialog, Snackbar,
  Table, TableRow, TableCell
} from "@mui/material";
import { Add, Remove, Delete } from "@mui/icons-material";
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { useSaveShoppingBagMutation, useGetShoppingBagMutation, useCreateOrderMutation } from "../../services/orders";
import { useGetInforMutation } from '../../services/auth';
import { setOrderQty } from '../../features/authSlice';
import ConfirmDialog from '../tools/comfirmDialog';
const API_URI = process.env.REACT_APP_API_URI;

const initialItems = [
  {
    id: 1,
    name: "Áo Lót Smooth Sensation Magic Có Gọng Mút Mỏng",
    price: 1432000,
    quantity: 1,
    image:
      "https://down-vn.img.susercontent.com/file/vn-11134207-7r98o-lszgbcc6r8pr73",
    size: "L",
    color: "Be",
  },
  {
    id: 2,
    name: "Quần Lót Aqua Moon Flower Mini",
    price: 294000,
    quantity: 2,
    image:
      "https://down-vn.img.susercontent.com/file/vn-11134207-7r98o-lrmyr3cw7w8m6e",
    size: "M",
    color: "Blue",
  },
];

export default function Cart() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [saveShoppingBag, saveShoppingBagResult] = useSaveShoppingBagMutation();
  const [getShoppingBag, shoppingBagResult] = useGetShoppingBagMutation();
  const [createOrder, createOrderResult] = useCreateOrderMutation();
  const [getInfor, inforResult] = useGetInforMutation();
  const [items, setItems] = useState(initialItems);
  const infor = useSelector(state => state.authUser.infor) || {};
  const [openPayment, setOpenPayment] = useState(false);
  const [alert, setAlert] = useState(false);
  const [itemEdit, setItemEdit] = useState({});
  const [total, setTotal] = useState({totalgross: 0, totalamount: 0, otherdiscount: 0, totalnet: 0, vatmoney: 0, lastmoney: 0});
  const [sumQty, setSumQty] = useState({countBra:0, aveBra:0, totalBra:0, countBrief:0, aveBrief:0, totalBrief:0, countOther:0, aveOther:0, totalOther:0});
  const [productTree, setProductTree] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const user = JSON.parse(window.localStorage.getItem('user')||"{}");

  useEffect(() => {
    getShoppingBag();
  }, []);

  useEffect(() => {
    if(shoppingBagResult.data)
    {
      const dt = JSON.parse(shoppingBagResult.data);
      setItems(dt);
    }
  }, [shoppingBagResult]);

  const handleQuantityChange = (record, delta) => {
    setItemEdit({...record});
    let prevItems = [...items];
    let chItem = prevItems.find(f=>f.id == record.id);
    let changeQty = Math.max(0, chItem.quantity + delta);
    chItem.quantity = changeQty;
    // setItems(prevItems);

    saveShoppingBag({...chItem, ImageSrcs: '', Images: '', ProductName: ''});
    // window.localStorage.setItem('orderItems', JSON.stringify(prevItems));
  };

  const handleSelect = (id) => {
    setItems(
      items.map((item) =>
        item.id === id ? { ...item, checked: !item.checked } : item
      )
    );

    // setSelected((prev) =>
    //   prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    // );
  };

  const handleRemove = (record) => {
    setItemEdit(record);
    setConfirm("Bạn có muốn xóa sản phẩm?");
  };

  const onConfirm=()=>{
    let prevItems = [...items];
    let chItem = prevItems.find(f=>f.id == itemEdit.id);
    saveShoppingBag({...chItem, ImageSrcs: '', Images: '', quantity: 0, ProductName: '', status: -1});
    setConfirm(false);
    // setItems((prev) => prev.filter((item) => item.id !== record.id));

    // dispatch(setOrderQty(prevItems.length-1));
    // window.localStorage.setItem('orderItems', JSON.stringify(prevItems));
  }

  const onChangeQty=(value, record)=>{
    setItemEdit({...record});
    const numericValue = Number(value);
    let changeQty = 0;
    if(Number.isInteger(numericValue))
      changeQty = (parseInt(value) < 0 ? 0 : parseInt(value));

    let prevItems = [...items];
    let chItem = prevItems.find(f=>f.id == record.id);
    chItem.quantity = changeQty;
    // setItems(prevItems);

    saveShoppingBag({...chItem, ImageSrcs: '', Images: '', ProductName: ''});

    // window.localStorage.setItem('orderItems', JSON.stringify(prevItems));
  }

  useEffect(() => {
    if(saveShoppingBagResult.data)
    {
      const dt = JSON.parse(saveShoppingBagResult.data);
      if(dt.length){
        if(dt[0].ERROR){
          setAlert(dt[0].ERROR);
          let prevItems = [...items];
          let chItem = prevItems.find(f=>f.id == itemEdit.id);
          chItem.quantity = parseInt(dt[0].OldQty);
          setItems(prevItems);
        }
        else{
          let prevItems = [...items];
          let chItem = prevItems.find(f=>f.id == itemEdit.id);
          chItem.quantity = parseInt(dt[0].Qty);
          
          if(dt[0].status == -1)
            prevItems = prevItems.filter(f=>f.id != itemEdit.id);

          setItems(prevItems);

          window.localStorage.setItem('orderItems', JSON.stringify(prevItems));
          if(dt[0].status == -1)
            dispatch(setOrderQty(prevItems.length));
        }
      }
    }
  }, [saveShoppingBagResult]);

  useEffect(() => {
    let tot =  items.filter((i) => i.checked).reduce((sum, item) => {
        return {
          totalgross: sum.totalgross + item.saleprice * item.quantity,
          totalamount: sum.totalamount + (item.saleprice/(1 + (infor.vat||0)/100.0)).toFixed(0) * item.quantity,
        };
      }, { totalgross: 0, totalamount: 0 });
    tot.totalamount = parseFloat(tot.totalamount.toFixed(0));
    tot.otherdiscount = parseFloat((tot.totalamount * (infor.CBDDiscount||0) / 100).toFixed(0));
    tot.totalnet = tot.totalamount - tot.otherdiscount;
    tot.vatmoney = parseFloat((tot.totalnet*((infor.vat||0)/100.0)).toFixed(0));
    tot.lastmoney = tot.totalnet + tot.vatmoney;
    setTotal(tot);
    // treeProducts();
    let stylecol = [];
    let sum =  items.filter((i) => i.checked).reduce((sum, item) => {
      const cc = stylecol.filter(f=> f==(item.StyleNo+item.Colors)).length==0?1:0;
      stylecol.push(item.StyleNo+item.Colors);
      return {
        countBra: sum.countBra + (item.ProGroup=='bra'?cc:0),
        totalBra: sum.totalBra + (item.ProGroup=='bra'?item.quantity:0),
        countBrief: sum.countBrief + (item.ProGroup=='brief'?cc:0),
        totalBrief: sum.totalBrief + (item.ProGroup=='brief'?item.quantity:0),
        countOther: sum.countOther + (item.ProGroup!='bra'&&item.ProGroup!='brief'?cc:0),
        totalOther: sum.totalOther + (item.ProGroup!='bra'&&item.ProGroup!='brief'?item.quantity:0),
      };
    }, { countBra: 0, totalBra: 0, countBrief: 0, totalBrief: 0, countOther: 0, totalOther: 0 });
    sum.aveBra = (sum.totalBra/(sum.countBra||1)).toFixed(2);
    sum.aveBrief = (sum.totalBrief/(sum.countBrief||1)).toFixed(2);
    sum.aveOther = (sum.totalOther/(sum.countOther||1)).toFixed(2);
    setSumQty(sum);
  }, [items]);
  
  // const total = items.filter((i) => i.checked)
  //   .reduce((sum, i) => sum + i.saleprice * i.quantity, 0);

  const allChecked = items.every((item) => item.checked);
  const someChecked = items.some((item) => item.checked);

  const handleCheckAll = (e) => {
    const checked = e.target.checked;
    setItems(items.map((item) => ({ ...item, checked })));
  };

  const handleCreateOrder = () => {
    let products = "";
    items.filter((i) => i.checked).map(m=>{
      products += `${m.styleColCupSize}|1${m.quantity}|2${m.saleprice}|3${m.promoid};`
    });

    createOrder({...total, vat: infor.vat, percentdiscount2: infor.CBDDiscount, products: products
      , totalpayment: (total.lastmoney - (infor.CASHREMAIN||0) > 0 ? (total.lastmoney - (infor.CASHREMAIN||0)) : 0)
    });
  };

  useEffect(() => {
    if(createOrderResult.data)
    {
      const dt = JSON.parse(createOrderResult.data);

      if(dt.length){
        if(dt[0].ID){
          let prevItems = [...items.filter(f=>(f.checked||false)==false)];
          setItems(prevItems);

          dispatch(setOrderQty(prevItems.length));
          window.localStorage.setItem('orderItems', JSON.stringify(prevItems));
          
          navigate("/orderlist", { replace: true });
        }
        else if(dt[0].ERROR){
            setAlert(dt[0].ERROR);
            setOpenPayment(false);
            getShoppingBag();
        }
        else
          setAlert("Lỗi kết nối vui lòng thử lại sau!");
      }
      else{
        setAlert("Lỗi kết nối vui lòng thử lại sau!");
      }
    }
  }, [createOrderResult]);

  const treeProducts=()=>{
    let styles = items.reduce((style, item)=>{
      const isDuplicate = style.some(i => i.StyleNo === item.StyleNo);
      if (!isDuplicate) {
        style.push(item);
      }
      return style;
    }, []);
    
    const treeItem = styles.map(m=>{
      if(m.StyleNo)
        return <TreeItem itemId={m.StyleNo} label={<Box sx={{display: 'flex', alignItems: "center", justifyContent: 'space-between'}}>
            <Box component="img"
              src={(m.Images?`${API_URI}/uploads/products/${m.Images}`:'') || m.ImageSrcs}
              alt="No_Image"
              sx={{ width: 50, height: 50, objectFit: "cover", borderRadius: 2, border: "1px solid #eee", 
                textAlign: "center", lineHeight: '18px', color: 'silver'}}
            />
            <Typography variant="subtitle1" fontWeight={600} sx={{width: '100%', marginLeft: 1}}>
              {m.ProductName}
            </Typography>
            <Typography variant="subtitle1" fontWeight={600}>
              {50}
            </Typography>
          </Box>}>
          {
            items.filter(f=>f.StyleNo == m.StyleNo).reduce((col, item)=>{
              const isDuplicate = col.some(i => i.Colors === item.Colors);
              if (!isDuplicate) {
                col.push(item);
              }
              return col;
            }, []).map(m1=>{
              return <TreeItem itemId={`${m.StyleNo}${m1.Colors}`} label={m1.Colors} selected/>
            })
          }
        </TreeItem>
    });
    setProductTree(treeItem);
  }

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#fafafa", minHeight: "100vh" }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, textAlign: "center" }}>
        GIỎ HÀNG
      </Typography>

      <Grid container spacing={2} sx={{justifyContent: "center"}}>
        {/* LEFT: Product list */}
        <Grid item xs={12} md={8} sx={{ width: {xs: "100%", md: "auto"} }}>
          <Paper sx={{ p: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  checked={allChecked}
                  indeterminate={!allChecked && someChecked}
                  onChange={handleCheckAll}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Chọn tất cả
                </Typography>
              </Box>
              <Typography color="text.secondary">
                {items.filter((item) => item.checked).length} sản phẩm được chọn
              </Typography>
            </Box>

            {items.map((item) => (
              <Box
                key={item.id}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "flex-start", sm: "center" },
                  gap: 2,
                  py: 2,
                  borderBottom: "1px solid #eee"
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Checkbox
                    checked={item.checked||false}
                    onChange={() => handleSelect(item.id)}
                  />

                  <Box
                    component="img"
                    src={(item.Images?`${API_URI}/uploads/products/${item.Images}`:'') || item.ImageSrcs}
                    alt="&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; No_Image"
                    sx={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: 2,
                      border: "1px solid #eee",
                      textAlign: "center", lineHeight: '18px', color: 'silver'
                    }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography fontWeight={600}>{item.ProductName}</Typography>
                  <Typography color="text.secondary" variant="body2">
                    Mã: {item.StyleNo} | Màu: {item.Colors} | Kích cỡ: {item.size}
                  </Typography>

                  {/* Quantity & Price */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      mt: 1,
                      flexWrap: "wrap",
                      flexDirection: "column"
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        onClick={() => handleQuantityChange(item, -1)}
                        size="small"
                      >
                        <Remove fontSize="small" />
                      </IconButton>
                      <TextField
                        size="small"
                        value={item.quantity}
                        sx={{ width: 50, mx: 1 }}
                        onChange={(e) => onChangeQty(e.target.value||0, item)}
                        slotProps={{
                          input: {
                            inputProps: {
                              inputMode: 'numeric',
                              pattern: '[0-9]*',
                              style: { textAlign: "center", height: 16 },
                              maxLength: 3
                            }
                          }
                        }}
                      />
                      <IconButton
                        onClick={() => handleQuantityChange(item, 1)}
                        size="small"
                      >
                        <Add fontSize="small" />
                      </IconButton>

                      <IconButton color="error" onClick={() => handleRemove(item)}>
                        <Delete />
                      </IconButton>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <Typography variant="body1" sx={{ color: 'red', fontWeight: 'bold' }}>
                      {item.saleprice?item.saleprice.toLocaleString('en-US'):0}₫
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ textDecoration: 'line-through', color: '#888' }}
                    >
                      {item.price?item.price.toLocaleString('en-US'):0}₫
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Paper>
        </Grid>

        {/* RIGHT: Summary */}
        <Grid item xs={12} md={4} sx={{ width: {xs: "100%", md: "auto"} }}>
          <Paper sx={{ p: 3, position: "sticky", top: 80 }}>
            <Typography variant="h6" fontWeight={600}>
              Tóm tắt đơn hàng
            </Typography>
            <Divider sx={{ my: 2 }} />

            {/* <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography>Số lượng sản phẩm:</Typography>
              <Typography fontWeight={600}>
                {items.filter((i) => i.checked).reduce((sum, i) => sum + i.quantity, 0)}
              </Typography>
            </Box> */}

            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography>Cộng tiền hàng:</Typography>
              <Typography fontWeight={600} color="error.main">
                {total.totalgross.toLocaleString()}₫
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography>Tổng trước VAT:</Typography>
              <Typography fontWeight={600}>
                {total.totalamount.toLocaleString()}₫
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography>Chiết khấu {infor.CBDDiscount||0}%:</Typography>
              <Typography fontWeight={600}>
                - {total.otherdiscount.toLocaleString()}₫
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography>VAT:</Typography>
              <Typography fontWeight={600}>
                {total.vatmoney.toLocaleString()}₫
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography fontWeight={600}>Tổng thanh toán:</Typography>
              <Typography fontWeight={600} color="blue">
                {total.lastmoney.toLocaleString()}₫
              </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />
            
            <Typography fontWeight={600} color="error.main" sx={{mb: 1, minWidth: '280px'}}>
              Đơn hàng tối thiểu từ 7 triệu đồng
            </Typography>
            
            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={total.lastmoney < 7000000}
              sx={{ py: 1.5, fontWeight: 600 }}
              onClick={()=>{ getInfor(); setOpenPayment(true); }}
            >
              Mua hàng
            </Button>
          </Paper>
        </Grid>
        {/* RIGHT: Summary */}
        <Grid item xs={12} md={4} sx={{ width: {xs: "100%", md: "auto"}, marginBottom: {xs: "80px", md: 0} }}>
          <Paper sx={{ p: 3, position: "sticky", top: 80 }}>
            <Typography variant="h6" fontWeight={600}>
              Tóm tắt số lượng
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography>Tổng số lượng hàng đặt:</Typography>
              <Typography fontWeight={600} sx={{ml: 2, color: 'error.main'}}>
                {items.filter((i) => i.checked).reduce((sum, i) => sum + i.quantity, 0)}
              </Typography>
            </Box>
            <Table>
              <TableRow>
                <TableCell></TableCell><TableCell>Số mã màu</TableCell><TableCell>Trung bình</TableCell><TableCell>Tổng số lượng</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Áo</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.countBra}</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.aveBra}</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.totalBra}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Quần</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.countBrief}</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.aveBrief}</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.totalBrief}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Khác</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.countOther}</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.aveOther}</TableCell><TableCell style={{textAlign: 'center'}}>{sumQty.totalOther}</TableCell>
              </TableRow>
            </Table>
            {/* <Box sx={{ minHeight: 352, minWidth: 250 }}>
              <SimpleTreeView checkboxSelection selectedItems={selectedItems}
                onSelectedItemsChange={handleSelectedItemsChange}
                multiSelect>
                {productTree}
              </SimpleTreeView>
            </Box> */}
          </Paper>
        </Grid>
      </Grid>

      <Dialog onClose={()=>setOpenPayment(false)} open={openPayment} maxWidth="xs"
        sx={{
          "& .MuiPaper-root": { margin: 0 }, // Chrome/Safari
        }} >
        {/* "HSBC","bin":"458761"; "code":"STB","bin":"970403"; "VCB","bin":"970436" */}
        <Box sx={{ display: "flex", flexDirection: "column", maxWidth: "370px", marginTop: 2 }}>
          <Typography fontWeight={600} color="error.main" marginLeft={1} marginRight={1}
            sx={{ position: 'absolute', backgroundColor: 'white', textAlign: 'center', fontSize: '15px', paddingTop: '6px' }}>
            CONG TY TNHH TRIUMPH INTERNATIONAL VIET NAM
          </Typography>

          <Box
            component="img"
            src={`https://img.vietqr.io/image/970436-0461000056868-abc.png?amount=${(total.lastmoney - (infor.CASHREMAIN||0) > 0 ? (total.lastmoney - (infor.CASHREMAIN||0)) : 0)}&addInfo=${user.username} ${user.fullname} COD&accountName=CONG TY TNHH TRIUMPH INTERNATIONAL VIET NAM`}
            alt={"triumph viet nam"}
            sx={{
              width: 300,
              height: 300,
              objectFit: "cover",
              borderRadius: 2,
              border: "1px solid #eee",
              alignSelf: "center"
            }}
          />

          <Box sx={{display: 'flex', flexDirection: 'row', marginTop: 1}}>
            <Typography fontWeight={600} marginLeft={1} width={'60%'}>
              Tài khoản còn lại
            </Typography>
            <Typography fontWeight={600} marginLeft={1} width={'40%'} textAlign={'right'} marginRight={1} color="green">
              {(infor.CASHREMAIN||0).toLocaleString()}₫
            </Typography>
          </Box>
          <Box sx={{display: 'flex', flexDirection: 'row'}}>
            <Typography fontWeight={600} marginLeft={1} width={'60%'}>
              Tổng tiền đơn hàng
            </Typography>
            <Typography fontWeight={600} marginLeft={1} width={'40%'} textAlign={'right'} marginRight={1} color="blue">
              {total.lastmoney.toLocaleString()}₫
            </Typography>
          </Box>
          <Box sx={{display: 'flex', flexDirection: 'row', marginBottom: 1}}>
            <Typography fontWeight={600} marginLeft={1} width={'60%'}>
              Cần thanh toán thêm
            </Typography>
            <Typography fontWeight={600} marginLeft={1} width={'40%'} textAlign={'right'} marginRight={1} color="red">
              {(total.lastmoney - (infor.CASHREMAIN||0) > 0 ? (total.lastmoney - (infor.CASHREMAIN||0)) : 0).toLocaleString()}₫
            </Typography>
          </Box>
          <Typography fontStyle={'italic'} marginLeft={1}>
            Vui lòng quét mã QR Code bên để thanh toán, hoặc chuyển khoản qua tài khoản ngân hàng
          </Typography>
          <Typography fontStyle={'italic'} marginLeft={1}>
            Ngân hàng HSBC: 001.004.100.101
          </Typography>
          <Typography fontStyle={'italic'} marginLeft={1}>
            Ngân hàng Vietcombank: 046.100.0056868
          </Typography>

          <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={createOrderResult.isLoading}
              sx={{ py: 1.5, fontWeight: 600, marginTop: 1 }}
              onClick={()=>handleCreateOrder()}
            >
              Xác nhận mua hàng
            </Button>
        </Box>
      </Dialog>
      
      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />

      <ConfirmDialog confirm={confirm} setConfirm={setConfirm} onConfirm={onConfirm}/>
    </Box>
  );
}
